import { FC } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type SelectionChipProps = PropsWithClassName<{
  label: string;
  selected: boolean;
  onClick: () => void;
}>;

const SelectionChip: FC<SelectionChipProps> = ({ label, selected, onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'px-4 py-3 rounded-2xl border text-sm font-dm text-left text-black transition-all',
      selected ? 'border-black border-2 font-semibold' : 'border-black/20 font-normal',
      className
    )}
  >
    {label}
  </button>
);

export default SelectionChip;
